import { ScopeProvider } from 'bunshi/react'
import React from 'react'

import { EditDiffButtonContent } from './components/EditDiffButtonContent'
import {
  diffsContext,
  onExecuteContext,
  renderSelectorContext,
} from './contexts'
import { editDiffButtonScope } from './molecules'

export type EditDiffButtonProps = {
  diffs: React.ContextType<typeof diffsContext>
  renderSelector: React.ContextType<typeof renderSelectorContext>
  onExecute?: React.ContextType<typeof onExecuteContext>
}

export const EditDiffButton = ({
  diffs,
  onExecute,
  renderSelector,
}: EditDiffButtonProps) => {
  const scopeValue = React.useMemo(() => Symbol(), [])

  return (
    <ScopeProvider scope={editDiffButtonScope} value={scopeValue}>
      <diffsContext.Provider value={diffs}>
        <renderSelectorContext.Provider value={renderSelector}>
          <onExecuteContext.Provider value={onExecute}>
            <EditDiffButtonContent />
          </onExecuteContext.Provider>
        </renderSelectorContext.Provider>
      </diffsContext.Provider>
    </ScopeProvider>
  )
}
